import { useAddSocialMediaBulk } from "@entities/brief/lib/hooks/useAddSocialMediaBulk";
import { useSuggestInfluencerByUsername } from "@entities/brief/lib/hooks/useSuggestInfluenceUsername";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { IAddSocialMediaBulkResponseRow } from "@shared/lib/types/influencer";
import { useEffect, useState } from "react";
import { AddCreatorModalSingle } from "./ui/AddCreatorModalSingle";
import { BulkAddModal } from "./ui/BulkAddModal";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export function AddCreator({ isOpen, onClose, onSuccess }: Props) {
  const [isSingleModalOpen, setIsSingleModalOpen] = useState(isOpen);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const { briefId } = useBriefStore();

  const { suggest, isSuggesting, isSuggested } =
    useSuggestInfluencerByUsername("");
  const [successData, setSuccessData] = useState<
    IAddSocialMediaBulkResponseRow[]
  >([]);

  const {
    addSocialMediaBulk,
    isAddingSocialMediaBulk,
    isAddedSocialMediaBulk,
  } = useAddSocialMediaBulk((data) => {
    setSuccessData(data);
  });

  useEffect(() => {
    setIsSingleModalOpen(isOpen);
  }, [isOpen]);

  const handleCloseSingle = () => {
    setIsSingleModalOpen(false);
    if (!isBulkModalOpen) {
      onClose();
    }
  };

  const handleCloseBulk = () => {
    setIsBulkModalOpen(false);
    if (!isSingleModalOpen) {
      onClose();
    }
  };

  const handleFinish = () => {
    setIsSingleModalOpen(false);
    setIsBulkModalOpen(false);
    setSuccessData([]);
    if (onSuccess) {
      onSuccess();
    } else {
      onClose();
    }
  };

  useEffect(() => {
    if (isSuggested) {
      handleFinish();
    }
  }, [isSuggested]);

  useEffect(() => {
    if (!isOpen) {
      setSuccessData([]);
    }
  }, [isOpen]);

  return (
    <>
      <AddCreatorModalSingle
        isOpen={isSingleModalOpen}
        onClose={handleCloseSingle}
        onAdd={(data) => {
          addSocialMediaBulk({
            addBy: {
              platform_username: {
                platform: data.platform,
                username: data.username,
              },
            },
          });
        }}
        onOpenBulk={() => {
          setIsSingleModalOpen(false);
          setTimeout(() => setIsBulkModalOpen(true), 200);
        }}
        isAdding={isAddingSocialMediaBulk}
        isAdded={isAddedSocialMediaBulk}
        successData={successData}
        isSuggesting={isSuggesting}
        handleSuggest={() => {
          if (successData.length === 0) return;
          suggest({
            data: {
              briefId,
              addBySocialMediaObjectIds: successData
                ?.filter((creator) => creator.status === "success")
                .map((creator) => ({
                  socialMediaObjectId: creator.socialMediaObjectId || "",
                  estViews: 0,
                })),
            },
          });
        }}
      />
      <BulkAddModal
        isOpen={isBulkModalOpen}
        onClose={handleCloseBulk}
        onSuccess={handleFinish}
      />
    </>
  );
}
